const organization_details = {
    departments: {
        leader: 'Руководитель',
        leaders: 'Руководители отдела',
        led_departments: 'Подчинённые отделы',
        edit_leaders: 'Настроить руководителей',
        add_leader: 'Добавить',
        remove_leader: 'Убрать',
        no_leaders: 'Руководители не назначены',
        local: 'Локальная настройка',
        managed_members: 'Участники в области управления',
        leader_scope_hint: 'Управляйте составом своих отделов и подотделов.',
        leader_permission_hint: 'Руководители управляют составом своих отделов и подотделов, но не ролями организации или структурой отделов.',
        primary_synced: 'Основной отдел управляется в Feishu.',
        status_active: 'Активен',
        status_suspended: 'Приостановлен',
        status_departed: 'Уволен',
        status_pending: 'Ожидает активации',
        search: 'Поиск',
        previous_page: 'Предыдущая страница',
        next_page: 'Следующая страница',
        directory_title: 'Участники организации',
        member_name: 'Участник',
        search_members: 'Поиск по имени или логину',
        include_descendants: 'Включить подразделы',
        no_members: 'Подходящих участников нет.',
        all_members: 'Все участники',
        all_departments: 'Все отделы',
        edit_member: 'Изменить отделы',
        add_child: 'Добавить подраздел',
        expand_department: 'Развернуть {{name}}',
        collapse_department: 'Свернуть {{name}}',
        title: 'Отделы',
        description: 'Управление отделами и назначениями участников этой организации.',
        create: 'Создать отдел',
        edit: 'Изменить отдел',
        name: 'Название отдела',
        parent: 'Родительский отдел',
        root: 'Без родительского отдела',
        id: 'ID отдела',
        members: 'Отделы участников',
        member_id: 'ID пользователя участника',
        primary: 'Основной отдел',
        none: 'Не задан',
        assignments: 'Назначения отделов',
        no_assignments: 'Назначений отделов пока нет.',
        assignment_hint: 'Назначьте локальные отделы и при необходимости основной отдел. Назначения из каталога доступны только для чтения.',
        empty: 'Отделов пока нет.',
        readonly: 'Вы можете просматривать отделы и свои назначения. Для изменений обратитесь к администратору организации.',
        load_error: 'Не удалось загрузить данные. Повторите попытку.',
        mutation_error: 'Не удалось сохранить. Проверьте права, членство и иерархию отделов.',
        loading: 'Загрузка…',
        synced: 'Управляется каталогом',
        choose: 'Поиск отделов',
        organizations_title: 'Организации и отделы',
        organizations_description: 'Выберите организацию для просмотра или управления её отделами.',
        no_organizations: 'Вы не состоите в организации. Обратитесь к администратору.',
        organization: 'Текущая организация',
        choose_organization: 'Выберите организацию',
        delete_title: 'Удалить отдел',
        delete_description: 'Удалить «{{name}}»? Сначала переместите участников и дочерние отделы.',
    },
    directory: {
        leaders_label: 'Руководство отделами',
        local_department_leader: 'Локально назначенный руководитель',
        status_active: 'Активен',
        status_suspended: 'Приостановлен',
        status_departed: 'Уволен',
        status_pending: 'Ожидает активации',
        profiles_label: 'Исходные профили',
        primary_label: 'Изменения основного отдела',
        deactivated_label: 'Отключаемые учётные записи организации',
        reactivated_label: 'Восстанавливаемые учётные записи организации',
        lifecycle_notice: 'Сохраняемые назначения ролей: {{count}}. При восстановлении возвращаются прежние права.',
        title: 'Каталог Feishu',
        description: 'Импортируйте отделы и участников в эту организацию через коннектор Feishu.',
        identity_notice: 'Используйте коннектор с включённой подготовкой каталога. Изменение идентификатора существующего коннектора требует миграции аккаунтов.',
        connector: 'ID коннектора Feishu',
        preview: 'Предпросмотр синхронизации',
        preview_title: 'Предпросмотр синхронизации',
        preview_description: 'Проверьте каталог перед импортом. Если он изменится, повторите предпросмотр.',
        import: 'Подтвердить синхронизацию',
        success: 'Импортировано отделов: {{departments}}, участников: {{users}}; создано аккаунтов: {{createdUsers}}. Удалено отделов: {{removedDepartments}}, членств: {{removedMemberships}}, связей с отделами: {{removedAssignments}}.',
        failure: 'Не удалось прочитать или импортировать каталог. Проверьте права и видимость коннектора и повторите предпросмотр.',
        behavior_title: 'Режим импорта',
        mode: 'Синхронизируются имена, аватары, отделы и основные отделы. Отсутствующие или неактивные участники теряют доступ только к этой организации; роли, локальные назначения, глобальные аккаунты и другие организации сохраняются. Почта и телефон остаются исходными данными и не становятся реквизитами входа.',
        limits: 'За импорт: 1000 отделов, 5000 пользователей, 10000 назначений; чтение до 60 секунд. Неполные и слишком большие импорты отклоняются.',
        counts: 'Отделы: {{departments}} · Участники: {{users}}',
        departments_label: 'Отделы',
        members_label: 'Участие в организациях',
        assignments_label: 'Принадлежность к отделам',
        item: 'Элемент',
        added: 'Добавить',
        updated: 'Обновить',
        removed: 'Удалить',
        cleanup_notice: 'Синхронизируются имена, аватары, отделы и основные отделы. Отсутствующие или неактивные участники теряют доступ только к этой организации; роли, локальные назначения, глобальные аккаунты и другие организации сохраняются. Почта и телефон остаются исходными данными и не становятся реквизитами входа.',
        conflicts_title: 'Синхронизация заблокирована: {{count}} конфликтов. Устраните локальные зависимости и повторите просмотр.',
        removals_title: 'Примеры удалений (до 20 на категорию)',
        local_child_department: 'Локальный дочерний отдел',
        unowned_assignment: 'Локальная или старая связь без подтверждённого источника',
        local_member_roles: 'Участнику назначены локальные роли',
        unlinked_identity: 'Идентичность каталога отвязана',
    },
    page_title: 'Детали организации',
    delete_confirmation: 'После удаления все участники потеряют свою членство и роли в данной организации. Это действие нельзя отменить.',
    organization_id: 'Идентификатор организации',
    settings_description: 'Организации представляют команды, бизнес-клиентов и партнерские компании, которые могут получить доступ к вашим приложениям.',
    name_placeholder: 'Название организации, не обязательно должно быть уникальным.',
    description_placeholder: 'Описание организации.',
    member: 'Участник',
    member_other: 'Участники',
    add_members_to_organization: 'Добавить участников в организацию {{name}}',
    add_members_to_organization_description: 'Найдите подходящих пользователей, выполнив поиск по имени, электронной почте, телефону или идентификатору пользователя. Существующие участники не отображаются в результатах поиска.',
    add_with_organization_role: 'Добавить с ролями организации',
    user: 'Пользователь',
    application: 'Приложение',
    application_other: 'Приложения',
    add_applications_to_organization: 'Добавить приложения в организацию {{name}}',
    add_applications_to_organization_description: 'Найдите подходящие приложения, выполнив поиск по ID приложения, названию или описанию. Существующие приложения не отображаются в результатах поиска.',
    at_least_one_application: 'Необходимо хотя бы одно приложение.',
    remove_application_from_organization: 'Удалить приложение из организации',
    remove_application_from_organization_description: 'После удаления приложение потеряет свою ассоциацию и роли в данной организации. Это действие нельзя отменить.',
    search_application_placeholder: 'Поиск по ID приложения, названию или описанию',
    roles: 'Роли организации',
    authorize_to_roles: 'Разрешить {{name}} доступ к следующим ролям:',
    edit_organization_roles: 'Редактирование ролей организации',
    edit_organization_roles_title: 'Редактирование ролей организации {{name}}',
    remove_user_from_organization: 'Удалить пользователя из организации',
    remove_user_from_organization_description: 'После удаления пользователь потеряет свое членство и роли в этой организации. Это действие нельзя отменить.',
    search_user_placeholder: 'Поиск по имени, электронной почте, телефону или идентификатору пользователя',
    at_least_one_user: 'Необходимо указать хотя бы одного пользователя.',
    organization_roles_tooltip: 'Назначенные роли {{type}} в данной организации.',
    custom_data: 'Кастомные данные',
    custom_data_tip: 'Кастомные данные представляют собой JSON-объект, который может использоваться для хранения дополнительных данных, связанных с организацией.',
    invalid_json_object: 'Некорректный JSON-объект.',
    branding: {
        name: 'Брендирование',
        description: 'Настройте опыт входа на уровне организации.',
        organization_level_sie: 'Опыт входа на уровне организации',
        organization_level_sie_switch: 'Включите опыт входа на уровне организации и настройте фирменный стиль. Если выключено, произойдет откат сначала к входу на уровне приложения, затем к универсальному опыту входа.',
        logo: 'Логотипы организации',
        logo_tooltip: 'Вы можете использовать идентификатор организации для отображения этого логотипа при входе в систему; потребуется темная версия логотипа, если в настройках omni sign-in включен темный режим. <a>Подробнее</a>',
    },
    jit: {
        title: 'Создание по требованию',
        description: 'Пользователи могут автоматически присоединиться к организации и получить роли при первом входе через некоторые методы аутентификации. Вы можете установить требования для создания по требованию.',
        email_domain: 'Почтовый домен для создания по требованию',
        email_domain_description: 'Новые пользователи, регистрирующиеся с проверенными адресами электронной почты или через социальный вход с проверенными адресами электронной почты, автоматически присоединятся к организации. <a>Подробнее</a>',
        email_domain_placeholder: 'Введите почтовые домены для создания по требованию',
        invalid_domain: 'Некорректный домен',
        domain_already_added: 'Домен уже добавлен',
        sso_enabled_domain_warning: 'Вы ввели один или несколько почтовых доменов, связанных с корпоративным SSO. Пользователи с этими почтовыми адресами будут следовать стандартному SSO процессу и не будут добавлены в эту организацию, если не настроено корпоративное SSO.',
        enterprise_sso: 'Корпоративное SSO',
        no_enterprise_connector_set: 'Вы еще не настроили ни одного корпоративного SSO-коннектора. Сначала добавьте коннекторы, чтобы включить корпоративное SSO. <a>Настроить</a>',
        add_enterprise_connector: 'Добавить корпоративный коннектор',
        enterprise_sso_description: 'Новые пользователи или существующие пользователи, впервые входящие с помощью корпоративного SSO, автоматически присоединятся к организации. <a>Подробнее</a>',
        organization_roles: 'Роли организации по умолчанию',
        organization_roles_description: 'Назначайте роли пользователям при присоединении к организации через создание по требованию.',
    },
    mfa: {
        title: 'Многофакторная аутентификация (MFA)',
        tip: 'Когда требуется MFA, пользователи без настроенной MFA будут отвергнуты при попытке обмена токена организации. Эта настройка не влияет на аутентификацию пользователей.',
        description: 'Требовать от пользователей настройки многофакторной аутентификации для доступа к этой организации.',
        no_mfa_warning: 'В вашем тенанте не включено ни одного метода многофакторной аутентификации. Пользователи не смогут получить доступ к этой организации, пока не будет включен хотя бы один <a>метод многофакторной аутентификации</a>.',
    },
};
export default Object.freeze(organization_details);
